import React from 'react';
import { Input } from 'antd';
import { v4 as uuid } from 'uuid';
// import { useDispatch, useSelector } from 'react-redux';
// import { setDataTableSearchKey } from 'store/reducer/mainSlice';

//const { Search } = Input;

function ColumnFilter({ column = {} }) {
	const { filterValue, setFilter } = column;

	// const searchObj = useSelector((state) => state.main.dSearchValue);
	// const dispatch = useDispatch();

	// const currentURLPath = window.location.pathname;
	// const columnKey = `${currentURLPath}_${column.Header}`;

	const onChangeHandler = (value) => {
		// dispatch(setDataTableSearchKey({ dSearchValue: { [columnKey]: value } }));
		setFilter(value || undefined);
	};

	// useEffect(() => {
	// 	const searchString = searchObj[columnKey];
	// 	if (searchString) {
	// 		setFilter(searchString);
	// 	}
	// }, [searchObj, columnKey]);

	return (
		<Input
			value={filterValue}
			id={uuid()}
			placeholder="Search"
			allowClear
			onChange={(e) => {
				onChangeHandler(e.target.value);
			}}
			// style={{ border: 'none' }}
			style={{ border: 'none', height: '25px' }}
			autoComplete="off"
		/>
	);
}

export default ColumnFilter;

export function TanStackColumnFilter({ column = {} }) {
	const filterValue = column.getFilterValue();

	const onChangeHandler = (value) => {
		// dispatch(setDataTableSearchKey({ dSearchValue: { [column.Header]: value } }));
		column.setFilterValue(value);
	};

	return <DebouncedInput value={filterValue} onChange={onChangeHandler} />;
}

function DebouncedInput({ value: initialValue, onChange, debounce = 500 }) {
	let random = Math.floor(Math.random() * 1000).toString();
	const [value, setValue] = React.useState(initialValue);

	React.useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			onChange(value);
		}, debounce);

		return () => clearTimeout(timeout);
	}, [value]);

	return (
		<Input
			value={value}
			id={'Column' + random}
			placeholder="Search"
			allowClear
			onChange={(e) => {
				setValue(e.target.value);
			}}
			// style={{ border: 'none', outline: 'none' }}
			autoComplete="off"
			style={{ border: 'none', height: '25px' }}
			// variant="borderless"
		/>
	);
}
